import styled from 'styled-components';


export const TeacherDetailsContainer=styled.div`


`